import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

if (document.getElementById("vue-newsletter")) {
    new Vue({
        delimiters: ["[[", "]]"],
        el: '#vue-newsletter',
        components: { 
            Multiselect
        },
        propsData: { ...document.getElementById("vue-newsletter").dataset },
        props: {
            sitekey: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                optionsNews: ['News France', 'News Europe'],
                optionsExpertise: [
                    'Contentieux des affaires',
                    'Contrats commerciaux et internationaux',
                    'Droit européen',
                    'IT & Données personnelles',
                    'Corporate M&A',
                    'Règlementaire santé',
                    'Droit public & commande publique',
                    'Restructuration',
                    'Financement',
                    'Droit fiscal',
                    'Private Equity',
                    'Droit de la concurrence',
                    'Immobilier et Construction',
                    'Brevets',
                    'Droit social',
                    'Droit de l\'environnement',
                    'Gestion patrimoniale',
                    'PI - Médias - Arts'
                ],
                disabled: false,
                form: {
                    options_news: [],
                    first_name: '',
                    last_name: '',
                    company: '',
                    email: '',
                    role:'',
                    address:'',
                    zipcode: '',
                    city: '',
                    rgpd: false,
                    recaptcha_response: ''
                },
                errors: {
                    first_name: '',
                    last_name: '',
                    company: '',
                    email: '',
                    role:'',
                    address:'',
                    zipcode: '',
                    city: '',
                    rgpd: '',
                    recaptcha_response: '',
                },
                success: false,
            }
        },
        mounted() {
            window.recaptchaCallback = this.recaptchaCallback;
        },
        methods: {
            recaptchaCallback(){
                this.$set(this.form, 'recaptcha_response', grecaptcha.getResponse())
                this.disabled = false
            },
            check () {
                if (this.$refs.formnewsletter.checkValidity()) {
                  return true
                } else {
                  this.$refs.formnewsletter.reportValidity()
                  return false
                }
            },
            resetErrors() {
                this.errors = {
                    first_name: '',
                    last_name: '',
                    company: '',
                    email: '',
                    role:'',
                    address:'',
                    zipcode: '',
                    city: '',
                    rgpd: '',
                    recaptcha_response: '',
                }
            },
            getErrors(errors) {
                const data = {}
                const err = errors.response.data.data.params
                for(let error of err) {
                    data[error] = 'Ce champ est requis'
                }
                return data
            },
            submitForm(e) {
                e.preventDefault();
                this.resetErrors()
                if (this.check()) {     
                    this.disabled = true
                    axios
                    .post("/api/v1/subscriptions", this.form,{headers: {'content-type': 'application/json',}})
                    .then(response => {
                        this.success = true
                        this.form = {
                            first_name: '',
                            last_name: '',
                            company: '',
                            email: '',
                            role:'',
                            address:'',
                            zipcode: '',
                            city: '',
                            rgpd: false,
                        }
                        this.disabled = false
                        setTimeout(() => {
                            grecaptcha.reset();
                            this.success = false
                        }, 2000)
                    })
                    .catch((error) => {
                        console.log('error', error)
                        this.errors = Object.assign(this.errors, error.response.data)
                        this.disabled = false
                        grecaptcha.reset();
                        this.success = false
                    })
                }
            }
        }
    })
}
